import { render, staticRenderFns } from "./SupplierComplaintRow.vue?vue&type=template&id=0ae3bd00&scoped=true&"
import script from "./SupplierComplaintRow.vue?vue&type=script&lang=ts&"
export * from "./SupplierComplaintRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3bd00",
  null
  
)

export default component.exports